import { UserInfo } from "@/common/data/ApplicationModels";
import { createContext, useContext, useEffect, useState } from "react";
import { getUserInfo } from "@/common/utils/api";
import { isUserAuthenticated } from "@/common/utils/helpers";

interface UserInfoContext {
  userInfo: UserInfo|null;
}

export const ApplicationInfoContext = createContext<UserInfoContext>(undefined!);

const ApplicationInfoProvider = ({ children }: any) => {
  const [userInfo, setUserInfo] = useState<UserInfo|null>(null);

  useEffect(() => {
    if (isUserAuthenticated()) {
      getUserInfo()
        .then(result => setUserInfo(result))
        .catch(_ => console.error("unable to get data from userinfo."));
    }
  }, []);

  return (
    <ApplicationInfoContext.Provider
      value={{
        userInfo,
      }}
    >
      {children}
    </ApplicationInfoContext.Provider>
  );
};

export const useApplicationInfo = () => useContext(ApplicationInfoContext);
export default ApplicationInfoProvider;
